export const API_URL = "https://api-cms-dragonland-production.up.railway.app/";
export const NO_AVATAR =
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRelYwSqfjzOV_CAB5zhBhQywUdXEsJ-q_Dxw&s";
